import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function LayoutIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.95 2.62H4.29a1.67 1.67 0 0 0-1.67 1.67v11.66c0 .922.748 1.67 1.67 1.67h11.66a1.67 1.67 0 0 0 1.67-1.67V4.29a1.67 1.67 0 0 0-1.67-1.67Zm-13.33 5h15m-10 10v-10"
      />
    </Icon>
  );
}
